import React from 'react'

const PageNotFound = () => {
  return (
    <div className='PNF'>
      <h1 className='display-1'>404</h1>
      <h3 className='display-3'>Page Non Trouvée</h3>
      <a href='/' className='Home-btn display-5 mt-5'>Accueil</a>
    </div>
  )
}

export default PageNotFound